import SearchRow from './searchRow';

export default SearchRow;
